module.exports = "pegasus/assets/tech/welcome/100.png";